import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet_icon-32",
  "use": "icon-sheet_icon-32-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sheet_icon-32\"><g transform=\"translate(-358 -165)\" stroke=\"currentColor\" fill=\"transparent\"><rect stroke-width=\"1.5\" x=\"361.75\" y=\"167.75\" width=\"16.5\" height=\"18.5\" rx=\"2\" /><path stroke-width=\"1.5\" stroke-linecap=\"round\" d=\"M369 173.5h6M369 180.5h6\" /><circle cx=\"365.5\" cy=\"173.5\" r=\"1\" /><circle cx=\"365.5\" cy=\"180.5\" r=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol